import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Header from "../components/Header";
import SearchInput from "../../../ui/SearchInput";
import Accordion from "../../../ui/Accordion";
import Modal from "../../../ui/Modal";

import { Formik, Field, isEmptyArray } from "formik";
import Form, { InputSection } from "../components/Form";
import Input from "../../../ui/Input";
import { DropDown, DropDownOptionsProps } from "../../../ui/DropDown";
import { postEndpoint, GetHook, putEndpoint } from "../../../api/api";
import { KPI_URL, MATRIX_URL } from "../../../api/urls";
import { get } from "../../../utils/get";
import { useParams, useLocation } from "react-router-dom";
import Axios from "../../../utils/axios";
import { TitleText } from "../../../ui/Text";
import { Button } from "../../../ui/Button";
import AlignmentOptions from "../Scorecard/KpiForms/AlignmentOptions";
import { ScorecardIcon } from "../../../assets/svg/ScorecardIcon";
import { OrganisationTypeIcon } from "../../../assets/svg/OrganisationTypeIcon";
import { SettingsIcon } from "../../../assets/svg/SettingsIcon";
import { toast } from "react-toastify";
import { CloseIcon } from "../../../assets/svg/CloseIcon";
import { CloseIcon2 } from "../../../assets/svg/CloseIcon2";
import Swal from "sweetalert2";
import { KPISchema } from "../../../utils/validationSchema/ScorecardConfigSchema/KPIschema";
import { CircleIcon } from "../../../assets/svg/CircleIcon";
import { parseDropdown } from "../../../utils/parseDropdown";
import { KPI_SEARCH_URL } from "../../../api/urls";

const KPIsComponent = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const [kpis, setKpis] = useState<any>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [kpiId, setKpiId] = useState();
  const [editData, setEditData] = useState<any>([]);
  const [step, setStep] = useState(1);
  const [scoringMatrix, setScoringMatrix] = useState<any>([]);
  const [filteredKpis, setFilteredKpis] = useState([]);
  const { id }: any = useParams();
  const { data: matrixs } = GetHook(MATRIX_URL);
  const [searchTerm, setSearchTerm] = useState('');
  const [existingKPI, setExistingKPI] = useState(null);

  const { data, error, pending, reload } = GetHook(
    `${KPI_URL}?objective_id=${id}`
  );

  const formRef: any = useRef<any>(null);
  const location = useLocation();

  const isAddMode = !kpiId;

  useEffect(() => {
    setKpis(data);
    return () => {};
  }, [id, data]);

  const handleAddKpi = (values) => {
    const payload = {
      scoring_matrix_id: get(values, "scoring_matrix.value"),
      name: get(values, "name"),
      notes: get(values, "notes"),
      kpi_type: get(values, "kpi_type.value"),
      target: get(values, "target"),
      optimisation: get(values, "optimisation.value"),
      score_type: get(values, "score_type.value"),
      alignment: get(values, "alignment.value"),
      supported_kpi_id: get(values, "supported_kpi.value"),
      objective_id: id,
    };

    createReq(KPI_URL, payload);
  };

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      // setKpis([data.returned_resultset[0], ...kpis]);
      toast.success("Kpi added successfully");
      reload(get(location, "key"));
      setisModalOpen(false);
    }

    return () => {};
  }, [createRes]);

  const setEdit = (kpi) => {
    setIsEdit(true);
    setKpiId(kpi.id);
    setEditData(kpi);
    setisModalOpen(true);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const closeModal = () => {
    setisModalOpen(false);
    setIsEdit(false);
    setKpiId(undefined);
    setStep(1);
    formRef.current.resetForm(initialValues);
  };
  
  useEffect(() => {
    if (!isAddMode && isEdit) {
      const editMatrix = matrixs
      .filter(
        (obj) =>
          get(obj, "id") === get(editData, "scoring_matrix_id")
      )
      .map((x) => {
        return { value: get(x, "id"), label: get(x, "name") };
      });
      const newEditData = {
        ...editData,
        kpi_type: {
          value: get(editData, "kpi_type"),
          label: get(editData, "kpi_type"),
        },
        optimisation: {
          value: get(editData, "optimisation"),
          label: get(editData, "optimisation"),
        },
        score_type: {
          value: get(editData, "score_type"),
          label: get(editData, "score_type"),
        },
        supported_kpi: {
          value: get(editData, "supported_kpi.id"),
          label: get(editData, "supported_kpi.name"),
        },
        alignment: {
          value: get(editData, "alignment"),
          label: get(editData, "alignment"),
        },
        scoring_matrix:{
          value: get(editMatrix,"[0]value"),
          label: get(editMatrix,"[0]label"),
        },
        
      };
      const fields = [
        "scoring_matrix",
        "name",
        "notes",
        "max_score",
        "min_score",
        "target",
        "kpi_type",
        "optimisation",
        "score_type",
        "alignment",
        "supported_kpi",
      ];

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );  
          
    }
  }, [isAddMode]);

  const editKpi = (values) => {
    const payload: any = {
      scoring_matrix_id: get(values, "scoring_matrix.value"),
      name: get(values, "name"),
      kpi_type: get(values, "kpi_type.value"),
      target: get(values, "target"),
      notes: get(values, "notes"),
      optimisation: get(values, "optimisation.value"),
      alignment: get(values, "alignment.value"),
      score_type: get(values, "score_type.value"),
      supported_kpi_id: get(values, "supported_kpi.value"),
      objective_id: id,
    };
    if (
      get(values, "threshold") &&
      get(values, "threshold_type") &&
      get(values, "score")
    ) {
      payload.score_matrix = scoringMatrix;
    }
    updateReq(`${KPI_URL}/${kpiId}`, payload);
  };

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) toast.error(get(data, "message"));
    if (!pending && complete && !error) {
      toast.success("Kpi updated successfully");
      closeModal();
      reload(get(location, "key"));
    }
  }, [setisModalOpen, updateRes]);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          Axios.delete(`${KPI_URL}/${id}`)
            .then((res) => {
              setKpis(kpis.filter((kpi: any) => kpi.id != id));
              toast.success("KPI has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const nextStep = () => {
    setStep(step + 1);
  };
  const previousStep = () => {
    setStep(step - 1);
  };

  const renderAddKpi = (values) => {
    const kpiOptions: DropDownOptionsProps = [
      { value: "leading", label: "leading" },
      { value: "lagging", label: "lagging" },
    ];
    const optimisationOptions = [
      {
        value: "maximise",
        label: "maximise",
      },
      {
        value: "minimise",
        label: "minimise",
      },
    ];

    const scoreTypeOptions = [
      {
        value: "percent",
        label: "percent",
      },
      {
        value: "numeric",
        label: "numeric",
      },
      {
        value: "KES",
        label: "KES",
      },
      {
        value: "hours",
        label: "hours",
      },
      {
        value: "days",
        label: "days",
      },
      {
        value: "weeks",
        label: "weeks",
      },
      {
        value: "months",
        label: "months",
      },
    ];
    switch (step) {
      case 1:
        return (
          <Form>
            <InputSection>
              <Field
                name="name"
                placeholder="enter kpi name"
                label="KPI name"
                component={Input}
                width="96%"
                isBordered={true}
              />
            </InputSection>
            {existingKPI && <div>Existing KPI: {existingKPI}</div>}
            <InputSection>
              <Field
                name="notes"
                placeholder="description"
                label="Description"
                type="textarea"
                component={Input}
                width="96%"
                height="6em"
                isBordered={true}
              />
            </InputSection>
            <Field
              name="score_type"
              dropdownLabel="Data Type"
              component={DropDown}
              width="87%"
              options={scoreTypeOptions}
              isBordered={true}
              backgroundColor="#F5F6FB"
            />
            <Field
              name="kpi_type"
              dropdownLabel="KPI Type"
              component={DropDown}
              options={kpiOptions}
              isBordered={true}
              width="18em"
              backgroundColor="#F5F6FB"
            />
            <Field
              name="optimisation"
              dropdownLabel="Optimisation"
              component={DropDown}
              options={optimisationOptions}
              isBordered={true}
              width="18em"
              backgroundColor="#F5F6FB"
            />
          </Form>
        );
      case 2:
        return <AlignmentOptions kpiOptions={kpis} values={values} />;
      case 3:
        return(
          <Form>
            <InputSection>
            <Field
              name="scoring_matrix"
              placeholder="select scoring Matrix"
              dropdownLabel="Scoring Matrix"
              width="97%"
              options={parseDropdown(matrixs)}
              isBordered={true}
              component={DropDown}
            />
            </InputSection>
          </Form>
        );
    }
  };
  const initialValues = {
    name: "",
    score_type: "",
    weight: "",
    baseline: "",
    optimisation: "",
    kpi_type: "",
    supported_kpi: "",
    alignment: "",
    notes: "",
  };

  const handleKpiSearch = (e) => {
    const filtered = kpis.filter((kpi) =>
      kpi.name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    if (e?.target.value) {
      setFilteredKpis(filtered);
      setSearchQuery(e);
    } else {
      setFilteredKpis([]);
    }
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      // validationSchema={KPISchema}
      onSubmit={isAddMode ? (values) => handleAddKpi(values) : editKpi}
    >
      {({ handleSubmit, values }) => (
        <KPIsContainer>
          <Header title="KPIs" setisModalOpen={setisModalOpen} />
          {isModalOpen && (
            <Modal
              title={!isEdit ? "Add new KPI" : "Edit kpi"}
              handleSubmit={handleSubmit}
              closeModal={closeModal}
              noFooter
            >
              <WizzardHeader>
                <HeaderItem enabled={step === 1 ? true : false}>
                  <ScorecardIcon isActive />
                  <TitleText>KPI parameters</TitleText>
                </HeaderItem>
                <HeaderItem enabled={step === 2 ? true : false}>
                  <OrganisationTypeIcon isActive />

                  <TitleText>Alignment</TitleText>
                </HeaderItem>
                <HeaderItem enabled={step === 3 ? true : false}>
                  <CircleIcon isActive />

                  <TitleText>Scoring Matrix</TitleText>
                </HeaderItem>
              </WizzardHeader>
              {renderAddKpi(values)}
              <Footer>
                <Button text="Cancel" backgroundColor="#fff" color="#214160" />
                <ButtonWithBorder
                  disabled={step === 1 ? true : false}
                  text="Back"
                  onClick={previousStep}
                  backgroundColor="#fff"
                  color="#214160"
                />
                {step === 3 ? (
                  <SmallButton
                    text="Finish"
                    type="submit"
                    onClick={() => handleSubmit()}
                  />
                ) : (
                  <SmallButton text="Next" onClick={nextStep} />
                )}
              </Footer>
            </Modal>
          )}
          <SearchInput handleChange={handleKpiSearch} />
          <ListContainer>
            {(filteredKpis.length ? filteredKpis : kpis).map((kpi) => (
              <Accordion
                kpi={kpi}
                isConfig
                showEdit={setEdit}
                handleDelete={() => handleDelete(kpi.id)}
              />
            ))}
          </ListContainer>
        </KPIsContainer>
      )}
    </Formik>
  );
};

export default KPIsComponent;

const KPIsContainer = styled.div`
  display: grid;
  grid-template-rows: 5em 4.25em auto;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
`;

const WizzardHeader = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  border: 2px solid rgba(76, 92, 251, 0.1);
  border-radius: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const HeaderItem = styled.button<{ enabled: boolean }>`
  display: flex;
  font-size: 12;
  font-weight: 600;
  align-items: center;
  background-color: ${(props) => (props.enabled ? "#EBEFFF" : "#fff")};
  color: #01A8CE;
  padding: 1em 1.5em 1em 1.5em;
  border-radius: 1em;
  width: 100%;
  box-shadow: 0px 0px 0px transparent;
  border: 1px solid transparent;
  text-shadow: 0px 0px 0px transparent;
  border-color: ${(props) =>
    props.enabled ? "rgba(1,168,206,1)" : "none"};
  opacity: ${(props) => (props.enabled ? 1 : 0.4)};
  ${TitleText} {
    padding-left: 1em;
    color: #01A8CE;
    font-size: 12px;
  }
  &:focus {
    outline: none;
  }
`;

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1em;
`;

const ButtonWithBorder = styled(Button)<{ disabled: boolean }>`
  border: 2px solid #01A8CE;
  padding: 0.3em 4em;
  margin-left: auto;
  margin-right: 1em;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`;

const SmallButton = styled(Button)`
  padding: 0.4em 4em;
  border: 2px solid #01A8CE;
`;

const ScoringContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
`;

const ScoringSectionHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  ${TitleText} {
    color: #c4c9fe;
  }
`;

const ScoringSection = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 1.1fr 1fr 0.5fr;
  align-items: center;
  grid-gap: 1em;
  ${TitleText} {
    font-weight: normal;
    opacity: 0.9;
  }
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
